module.exports = __webpack_public_path__ + "assets/img/img45.cbfcea82.png";